import { WingieHeaderLinks } from 'utils/wingieApiLinks'

const replaceUrls = (links, host) => {
  return links?.map((link) => {
    return {
      ...link,
      href: link.href.replace('{{URL}}', host),
    }
  })
}

const getDomainNativeLanguage = (host) => {
  // Domain'lerin native language'lerini tanımla
  const domainLanguageMap = {
    'wingie.com': 'en',
    'wingie.es': 'es',
    'wingie.ru': 'ru',
    'wingie.de': 'de',
    'wingie.qa': 'ar',
    'wingie.ae': 'ar',
    'wingie.co.in': 'en',
    'www.wingie.az': 'az',
    'au.wingie.com': 'en',
    'sa.wingie.com': 'ar',
    'eg.wingie.com': 'ar',
    'kg.wingie.com': 'ky',
    'om.wingie.com': 'ar',
    'bh.wingie.com': 'ar',
    'jo.wingie.com': 'ar',
    'pk.wingie.com': 'en',
    'kz.wingie.com': 'kk',
    'uz.wingie.com': 'uz',
    'tj.wingie.com': 'tg',
    'lb.wingie.com': 'ar',
    'ca.wingie.com': 'en',
    'iq.wingie.com': 'ar',
    'ma.wingie.com': 'ar',
    'ge.wingie.com': 'en',
    'mx.wingie.com': 'es',
  }

  // Host'tan domain'i çıkar ve karşılık gelen language'i bul
  for (const [domain, lang] of Object.entries(domainLanguageMap)) {
    if (host.includes(domain)) {
      return lang
    }
  }

  return null
}

const filterFaqLinks = (links, host, expansionLocale, language) => {
  const domainNativeLanguage = getDomainNativeLanguage(host)

  // Eğer domain native language'i varsa ve current language farklıysa FAQ linkini filtrele
  if (domainNativeLanguage && language !== domainNativeLanguage) {
    return links?.filter((link) => !link.href.includes('/faq/'))
  }

  return links
}

export const applyApiHeaderLinkOverrides = (links, headerLinks?: WingieHeaderLinks | null) => {
  if (!headerLinks || !links) return links

  return links.map((link) => {
    const href = link?.href || ''

    if (headerLinks.faq && href.includes('/faq')) {
      return { ...link, href: headerLinks.faq }
    }

    if (headerLinks.contact && (href.includes('/contact') || href.includes('/contacto'))) {
      return { ...link, href: headerLinks.contact }
    }

    return link
  })
}

export const getHeaderLinks = (host, expansionLocale, data, language, headerLinks?: WingieHeaderLinks | null) => {
  if (host.includes('www.enuygun.com')) return []

  const linksWithUrls = replaceUrls(data, host)
  const withApiOverrides = applyApiHeaderLinkOverrides(linksWithUrls, headerLinks)
  return filterFaqLinks(withApiOverrides, host, expansionLocale, language)
}

export default getHeaderLinks
